import { Link } from "react-router";
import SkillsSection from "#app/components/skillsSection.tsx";
import WatchCTA from "../resources+/watch-cta";
import { type Route } from "./+types/about";

export const meta: Route.MetaFunction = () => {
	var title = "JaseOwns - About";
	var description = "I am Jason Ramsey, aka JaseOwns, a seasoned developer with an unwavering passion for crafting exceptional digital experiences.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/creator_jase.jpg"},
		{ property: "og:image:alt", content: "JaseOwns Headshot Image"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export default function AboutRoute() {
	return (
		<main className="container mx-auto text-black dark:text-white">
			<h1 className="text-3xl px-4 sm:px-6 md:px-8 lg:px-10 text-cyan-900 dark:text-cyan-200">About JaseOwns</h1>

		<div className="px-4 md:px-10">
			<div className="flex flex-col md:flex-row my-6">Welcome to my digital corner of the internet! I'm Jason Ramsey, aka JaseOwns. Here's a quick look at my journey and what I'm currently doing:</div>
			<div className="flex flex-col space-y-6 md:space-y-0 md:space-x-6 md:flex-row space-x-0">
				<div className="space-y-6 mb-10">
<p>I started teaching myself HTML at 12, creating my first website on Geocities with screenshots from Ultima Online. This early dive into web development sparked my passion and set the direction for my career.</p>
<img className="mx-auto md:mr-6 lg:mr-10 max-w-xs md:max-w-md w-full md:w-64 md:h-64 md:float-left" src="/images/creator_jase.png" alt="Jason with headset" />

<p>For nearly two decades, I worked for the online dating service Match.com, developing user interfaces and backend systems. This role sharpened my skills in creating smooth and secure online experiences.</p>
<p>Now, I'm focusing on my YouTube channel and streaming on Twitch, mainly around gaming and coding. These platforms allow me to share my passion for games like Ultima Online, which first introduced me to programming.</p>
<p>I also run my own company: <b>Jase Owns LLC</b>. I'm building <a href="https://uoaddicts.com" className='underline'>UOAddicts.com</a>, a social media site for Ultima Online players. It's designed to be the go-to resource for the UO community.  It is an expansion pack for the <a href="https://uorazorscripts.com" className='underline'>UORazorscripts.com</a> website I have been running since 2022.</p>
<p>Alongside my content creation, I take on contract work, applying my skills to solve diverse challenges across industries. If you are <Link to="/contact" className='underline'>looking for a developer</Link>, don't hesitate to reach out so we can discuss your needs and how I can help.</p>

<p>Outside of my professional life, I'm a proud husband and father of three girls. Embracing the role of #girldad, I balance family life with my technological pursuits.</p>

<p>I'm always learning and solving problems, eager to stay ahead of tech trends. My goal is to create solutions that exceed expectations, whether in connecting people or enhancing digital interactions.</p>

				</div>
			</div>
		</div>

		<div className="p-4 sm:p-6 md:p-8 lg:p-10 bg-slate-200 dark:bg-slate-900">
			<p className="italic"><b className="font-bold">TLDR:</b> I'm a developer, content creator, and family man at the intersection of tech and gaming, dedicated to improving digital experiences and community engagement.</p>
			<p className="py-2">Available for <Link to="/contact" className='underline'>contract work</Link> and <Link to="/partnerships" className='underline'>partnerships</Link></p>
		</div>

		<SkillsSection className="px-4 sm:px-6 md:px-8 lg:px-10 mt-12" />

			<div className="p-4 sm:p-6 md:p-8 lg:p-10">
				<h1 className="text-3xl text-left my-6 text-cyan-900 dark:text-cyan-200">What is next for Jase?</h1>
				<div className="my-6 text-left">
					My personal goal is to become better with routine <Link to="/blog/starting-a-routine-again" className="underline" >(like this post from in 2023)</Link> and <Link to="/blog/still-grinding-mid-year-checkpoint-2025" className="underline">still working on it in 2025</Link>. I am continuing to grow my skills through writing and entertainment.  I am turning my passion for programming and gaming into fun, educational content on Youtube and this website. Big plans for growing my <Link to="/dev" className="underline" >Ultima Online projects</Link> so be sure to check them out!
				</div>
			</div>
			{WatchCTA()}
		</main>
	)
}



